import { Component, ChangeDetectorRef, Inject, OnInit } from '@angular/core';
import { lastValueFrom } from '@services';
import { RmsModule } from '@rms';
import { OrdersDataService } from '../../../../../services/orders-data.service';
import { RmsPulldownRef } from '../../../../../custom-modules/rms-module/rms-pulldown/rms-pulldown-ref';
import { RMS_PULLDOWN_DATA } from '../../../../../custom-modules/rms-module/rms-pulldown/rms-pulldown.tokens';

@Component({
  selector: 'app-order-detail-view',
  imports: [RmsModule],
  templateUrl: './order-detail-view.component.html',
  styleUrl: './order-detail-view.component.scss'
})
export class OrderDetailViewComponent implements OnInit {
  OrderID!: number;

  Order: any = null;
  LineItems: any[] = [];
  ActionHistory: any[] = [];
  ShippingAddresses: any[] = [];
  Loading = true;
  Cancelling = false;

  constructor(
    private ordersData: OrdersDataService,
    private pulldownRef: RmsPulldownRef,
    private cdr: ChangeDetectorRef,
    @Inject(RMS_PULLDOWN_DATA) private pulldownData: { OrderID: number }
  ) { }

  async ngOnInit() {
    this.OrderID = this.pulldownData.OrderID;

    this.Loading = true;
    try {
      const result = await lastValueFrom(this.ordersData.getOrderDetails(this.OrderID));
      this.Order = result?.order ?? null;
      this.LineItems = result?.lineItems ?? [];
      this.ActionHistory = result?.actionHistory ?? [];
      this.ShippingAddresses = this.Order?.ShippingAddresses ?? [];
    } finally {
      this.Loading = false;
    }

    this.cdr.markForCheck();
  }

  get totalBags(): number {
    return this.LineItems.reduce((sum, i) => sum + (i.NumberOfBags ?? 0), 0);
  }

  async cancelThisOrder() {
    if (!this.OrderID) return;
    const reason = window.prompt('Reason for cancelling this order (optional):') ?? undefined;

    this.Cancelling = true;
    try {
      await lastValueFrom(this.ordersData.cancelOrder(this.OrderID, reason));
      this.pulldownRef.close(this.OrderID);
    } finally {
      this.Cancelling = false;
      this.cdr.markForCheck();
    }
  }

  returnToList() {
    this.pulldownRef.close(null);
  }
}
